import type { ChatMessageOptionsProps } from '@/shared/types/chatMessageButtonTypes';
import { chatMessageButtons } from '@/shared/utils/chatMessageButtons';

export function ChatMessageOptions({ metadata, choices, onDark = false }: ChatMessageOptionsProps) {
  const options = choices === undefined ? chatMessageButtons(metadata) : choices;
  if (!options) return null;

  return (
    <div
      role="group"
      className="flex flex-col gap-1.5 border-t border-current/20 pt-2"
      aria-label="Opções enviadas"
    >
      {options.title ? <span className="text-caption font-medium">{options.title}</span> : null}
      {options.buttons.map((choice, index) => (
        <div
          key={`${choice.label}-${index}`}
          className={`rounded-[8px] border px-3 py-2 text-center font-medium ${onDark ? 'border-white/40 text-white' : 'border-brand-200 text-brand-700'}`}
        >
          <span>{choice.label}</span>
          {choice.detail ? (
            <span className="text-caption block font-normal">{choice.detail}</span>
          ) : null}
        </div>
      ))}
    </div>
  );
}
